export default {
    state: {
        title: "",
        content: "",
        variant: "",
        visible: false,
        autoHideDelay: 4000
    },

    mutations: {
        showSuccess(state, data) {
            state.title = data.title
            state.content = data.content
            state.variant = "success"
            state.visible = !state.visible
            state.autoHideDelay = 4000
        },
        showWarning(state, data) {
            state.title = data.title
            state.content = data.content
            state.variant = "warning"
            state.visible = !state.visible
            state.autoHideDelay = 4000
        },
        showError(state, data) {
            state.title = data.title
            state.content = data.content
            state.variant = "danger"
            state.visible = !state.visible
            state.autoHideDelay = 4000
        },
        showInfo(state, data) {
            state.title = data.title
            state.content = data.content
            state.variant = "info"
            state.visible = !state.visible
            state.autoHideDelay = 4000
        }
    },

    namespaced: true
}